import { render } from "./generalDetails.vue?vue&type=template&id=d1253f4a&scoped=true"
import script from "./generalDetails.vue?vue&type=script&lang=js"
export * from "./generalDetails.vue?vue&type=script&lang=js"

import "./generalDetails.vue?vue&type=style&index=0&id=d1253f4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1253f4a"]])

export default __exports__